import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../Spinner/Spinner';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';
import { getPDF } from '../../api/index';
import useQuery from '../../utils/useQuery/useQuery';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';
import getConType from '../../utils/getConType/getConType';
import getSource from '../../utils/getSource/getSource';

const DownloadButton = ({
  resultsToSendToDelegator,
  downloadingPdf,
  setDownloadingPdf,
  setNotificationContent,
  setNotificationOpen,
  coldContactData,
  userComments,
}) => {
  const locId = useContext(LocaleContext);
  const urlQuery = useQuery();
  const conId =
    urlQuery.get('conId') && urlQuery.get('conId') !== '0'
      ? urlQuery.get('conId')
      : null;
  const utmSource = urlQuery.get('utm_source');
  const utmContent = urlQuery.get('utm_content');
  const conType = getConType(utmSource, utmContent);
  const faNo = urlQuery.get('faNo');
  const entityId = urlQuery.get('EID');
  const sourceForDelegator = getSource(utmSource, entityId, faNo, conId);
  const download = async () => {
    setDownloadingPdf(true);
    let byteString;
    const fileName = 'StartingPoint-Results.pdf';
    addDataLayerTrigger('download-results');

    try {
      byteString = await getPDF({
        resultsToSendToDelegator,
        conId,
        contactName:
          coldContactData &&
          coldContactData.firstName &&
          coldContactData.lastName
            ? `${coldContactData.firstName} ${coldContactData.lastName}`
            : null,
        locId,
        conType,
        utmSource: sourceForDelegator,
        userComments,
        faNo: faNo || null,
        entityId: entityId || null,
      });
      // IE & Edge Legacy
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(byteString, fileName);
      } else {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([byteString], { type: 'application/pdf' })
        );
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      setNotificationContent({
        type: 'error',
        text: getText(locId, 'Results', 'downloadError'),
      });
      setNotificationOpen(true);
    }

    setDownloadingPdf(false);
  };

  return (
    <span>
      {downloadingPdf ? (
        <Spinner />
      ) : (
        <div className="download">
          <button
            type="button"
            id="results-download"
            data-testid="results-download"
            className="button button-super download-results-button"
            onClick={download}
          >
            {getText(locId, 'Results', 'downloadPdfButton')}
          </button>
        </div>
      )}
    </span>
  );
};

DownloadButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  resultsToSendToDelegator: PropTypes.object.isRequired,
  downloadingPdf: PropTypes.bool.isRequired,
  setDownloadingPdf: PropTypes.func.isRequired,
  setNotificationContent: PropTypes.func.isRequired,
  setNotificationOpen: PropTypes.func.isRequired,
  coldContactData: PropTypes.objectOf(PropTypes.string),
  userComments: PropTypes.string,
};
DownloadButton.defaultProps = {
  coldContactData: {},
  userComments: '',
};

export default DownloadButton;
